// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { type RequestMileageConfigurationApiModel } from '../api-models/RequestMileageConfigurationApiModel'

export interface MileageLockSettingWriteInput {
  rate: string
  currencyId: number
  isLocked: boolean
}

export const mapMileageLockSettingWritePayload = ({
  rate,
  currencyId,
  isLocked,
}: MileageLockSettingWriteInput): RequestMileageConfigurationApiModel['value'] => ({
  currency_id: currencyId,
  is_locked: isLocked,
  rate,
})
